import iOS from 'is-ios';
import { useState } from 'react';
import Slider from 'react-slick';
import { ChoosePaymentCard } from '../../component/ChoosePaymentCard';
import './SlickSliderStyle.css';

interface paymentMethod {
  channelData: any;
  channel: string;
  callBackOnSelectChannel: any;
}

export function PaymentCardSlider(props: paymentMethod) {
  const { channelData, channel, callBackOnSelectChannel } = props;
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: true,
    initialSlide: 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    infinite: false,
    swipe: window.innerWidth > 770 ? false : true,
    // @ts-ignore
    afterChange: (current) => {
      setActiveSlide(current);
    },
    // @ts-ignore
    customPaging: (i) => {
      if (iOS) {
        if (activeSlide >= channelData.length - 1 && window.innerWidth > 320) {
          return <div className="ft-slick__dots--custom_last" />;
        }
        return <div className="ft-slick__dots--custom" />;
      }
      if (activeSlide >= channelData.length - 1 && window.innerWidth > 320) {
        return <div className="ft-slick__dots--custom_last_android" />;
      }
      return <div className="ft-slick__dots--custom_android" />;
    },

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 1.85,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.65,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1.4,
        },
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 1.25,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {channelData.map(
        (i: { title: string; isDisable: boolean | undefined; isfee: boolean | undefined; image: string }) => {
          return (
            <ChoosePaymentCard
              key={'choosePaymentCard' + i.title}
              callBack={callBackOnSelectChannel}
              selectedChannel={channel}
              title={i.title}
              isFee={i.isfee}
              image={i.image}
            />
          );
        },
      )}
      {window.innerWidth <= 320 ? null : <div style={{ display: 'none', width: '1px' }} />}
    </Slider>
  );
}
